import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconRadiusTopLeft12 from './IconRadiusTopLeft12';
import IconRadiusTopLeft16 from './IconRadiusTopLeft16';
import IconRadiusTopLeft20 from './IconRadiusTopLeft20';
import IconRadiusTopLeft24 from './IconRadiusTopLeft24';
import IconRadiusTopLeft32 from './IconRadiusTopLeft32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconRadiusTopLeft = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconRadiusTopLeft12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconRadiusTopLeft16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconRadiusTopLeft20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconRadiusTopLeft24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconRadiusTopLeft32 {...props} />}
        </span>
    );
};
IconRadiusTopLeft.displayName = 'FondueIconRadiusTopLeft';

export default memo(IconRadiusTopLeft);
